import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Link } from "react-router-dom";
import { useCart } from "../../context/cart-context";
import DeleteConfirmModal from "../global/DeleteConfirmModal";

export default function CartCard({ data }) {
  const [qty, setQty] = useState(data.quantity || 1);
  const [showDelete, setShowDelete] = useState(false);
  const { updateQuantity, removeFromCart } = useCart();

  useEffect(() => {
    updateQuantity(data.id, qty);
  }, [qty]);

  const handleConfirmDelete = () => {
    removeFromCart(data.id);
    setShowDelete(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 2, sm: 3 },
          py: { xs: 2.5, md: 3 },
          borderBottom: "1px solid #f3f4f6",
        }}
      >
        {/* Image */}
        <Box
          component={Link}
          to={`/shop/view/${data.slug}/${data.id}`}
          sx={{ display: "block", flexShrink: 0, textDecoration: "none" }}
        >
          <Box
            component="img"
            src={data.imgSrc}
            alt={data.name}
            sx={{
              width: { xs: 72, sm: 88, md: 96 },
              height: { xs: 72, sm: 88, md: 96 },
              objectFit: "cover",
              borderRadius: "8px",
              bgcolor: "#f9fafb",
              mixBlendMode: "multiply",
              display: "block",
            }}
          />
        </Box>

        {/* Name + unit price */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Link to={`/shop/view/${data.slug}/${data.id}`} style={{ textDecoration: "none" }}>
            <Typography
              sx={{
                fontSize: { xs: 13, md: 14 },
                fontWeight: 600,
                color: "#111827",
                lineHeight: 1.35,
                mb: 0.5,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {data.name}
            </Typography>
          </Link>
          <Typography sx={{ fontSize: 13, color: "#6b7280" }}>£{data.price}</Typography>
        </Box>

        {/* Qty stepper */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <Box
            onClick={() => setQty((q) => Math.max(1, q - 1))}
            sx={{ px: { xs: 1, md: 1.25 }, py: 0.875, cursor: "pointer", fontSize: 15, color: "#374151", userSelect: "none", "&:hover": { bgcolor: "#f3f4f6" } }}
          >
            –
          </Box>
          <Typography sx={{ px: { xs: 1.25, md: 1.5 }, fontSize: 13, fontWeight: 500, borderLeft: "1px solid #e5e7eb", borderRight: "1px solid #e5e7eb", lineHeight: "28px", color: "#111827" }}>
            {qty}
          </Typography>
          <Box
            onClick={() => setQty((q) => Math.min(data.limit || 99, q + 1))}
            sx={{ px: { xs: 1, md: 1.25 }, py: 0.875, cursor: "pointer", fontSize: 15, color: "#374151", userSelect: "none", "&:hover": { bgcolor: "#f3f4f6" } }}
          >
            +
          </Box>
        </Box>

        {/* Line total (hidden on mobile) */}
        <Typography
          sx={{ fontSize: 14, fontWeight: 600, color: "#194049", width: { sm: 76, md: 88 }, textAlign: "right", flexShrink: 0, display: { xs: "none", sm: "block" } }}
        >
          £{(data.price * qty).toFixed(2)}
        </Typography>

        {/* Delete */}
        <IconButton
          onClick={() => setShowDelete(true)}
          size="small"
          sx={{ color: "#d1d5db", "&:hover": { color: "#ef4444" }, flexShrink: 0 }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      {showDelete && (
        <DeleteConfirmModal
          item={{ name: data.name }}
          onClose={() => setShowDelete(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
    </>
  );
}
